<template>
    <v-app>
        <mainMenu></mainMenu>
        <v-container fluid>
            <v-card>
                <v-card-text>
                    <h1>Customer Group Report</h1>
                    <!-- <v-btn @click="getInv"></v-btn> -->
                    <!-- <v-btn @click="test">test</v-btn> -->
                    <hr>
                    <v-layout>
                        <v-flex xs1>
                            <v-select :items="itemYear" v-model="year" label="Year:" @change="searchYear"></v-select>
                        </v-flex>
                    </v-layout>
                    <v-data-table :headers="headerCust" :items="custGrp" class="elevation-1">
                        <template v-slot:no-data>
                            <!-- <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear> -->
                            <v-alert class="text-center" color="info" icon="info" :value="true" outline>
                                No data found
                            </v-alert>
                        </template>
                        <template v-slot:items="props">
                            <td>{{props.item.group}}</td>
                            <td class="text-xs-right">{{props.item['01'].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                            <td class="text-xs-right">{{props.item['02'].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                            <td class="text-xs-right">{{props.item['03'].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                            <td class="text-xs-right">{{props.item['04'].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                            <td class="text-xs-right">{{props.item['05'].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                            <td class="text-xs-right">{{props.item['06'].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                            <td class="text-xs-right">{{props.item['07'].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                            <td class="text-xs-right">{{props.item['08'].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                            <td class="text-xs-right">{{props.item['09'].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                            <td class="text-xs-right">{{props.item['10'].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                            <td class="text-xs-right">{{props.item['11'].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                            <td class="text-xs-right">{{props.item['12'].toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                            <td class="text-xs-right">
                                {{props.item.total =
                                    (
                                        props.item['01'] + 
                                        props.item['02'] + 
                                        props.item['03'] + 
                                        props.item['04'] +
                                        props.item['05'] +
                                        props.item['06'] +
                                        props.item['07'] +
                                        props.item['08'] +
                                        props.item['09'] +
                                        props.item['10'] +
                                        props.item['11'] +
                                        props.item['12']
                                    )
                                    .toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                }}
                            </td>
                        </template>
                        <template v-slot:footer>
                            <td><strong>Total:</strong></td>
                            <td class="text-xs-right"><strong>{{sum01.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</strong></td>
                            <td class="text-xs-right"><strong>{{sum02.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</strong></td>
                            <td class="text-xs-right"><strong>{{sum03.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</strong></td>
                            <td class="text-xs-right"><strong>{{sum04.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</strong></td>
                            <td class="text-xs-right"><strong>{{sum05.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</strong></td>
                            <td class="text-xs-right"><strong>{{sum06.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</strong></td>
                            <td class="text-xs-right"><strong>{{sum07.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</strong></td>
                            <td class="text-xs-right"><strong>{{sum08.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</strong></td>
                            <td class="text-xs-right"><strong>{{sum09.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</strong></td>
                            <td class="text-xs-right"><strong>{{sum10.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</strong></td>
                            <td class="text-xs-right"><strong>{{sum11.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</strong></td>
                            <td class="text-xs-right"><strong>{{sum12.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</strong></td>
                            <td class="text-xs-right"><strong>{{sumCf.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</strong></td>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-container>
    </v-app>
</template>
<script>
import {db} from '@/firebase'
import mainMenu from '@/components/mainMenu.vue'
export default {
    components:{
        mainMenu
    },
    data(){
        return{
            month: new Date().toISOString().substr(5,2) * 1,
            itemYear: [],
            year: new Date().toISOString().substr(0,4),

            headerCust:[
                { text: 'Customer group', align: 'left', value: 'group' },
                { text: 'Jan', align: 'right', value: '01' },
                { text: 'Fab', align: 'right', value: '02' },
                { text: 'Mar', align: 'right', value: '03' },
                { text: 'Apr', align: 'right', value: '04' },
                { text: 'May', align: 'right', value: '05' },
                { text: 'Jun', align: 'right', value: '06' },
                { text: 'Jul', align: 'right', value: '07' },
                { text: 'Aug', align: 'right', value: '08' },
                { text: 'Sep', align: 'right', value: '09' },
                { text: 'Oct', align: 'right', value: '10' },
                { text: 'Nov', align: 'right', value: '11' },
                { text: 'Dec', align: 'right', value: '12' },
                { text: 'Total', align: 'right', value: 'total' },
            ],
            detail:[],
            custGrp: [],
        }
    },
    methods:{
        searchYear(){
            let app = this
            let curYear = this.year*1 + 1
            db.collection("invoice").where("status", "==", "Open")
            .where("invDate", ">", this.year).where("invDate", "<", curYear.toString()).get()
            .then(query=>{
                let arrInv = []
                this.custGrp = []
                query.forEach(doc=>{
                    arrInv.push(doc.data())
                })
                if(arrInv.length == 0){
                    alert("Data does not exist in the system.")
                }
                else{
                    db.collection("invoice").where("status", "==", "Closed")
                    .where("invDate", ">", this.year).where("invDate", "<", curYear.toString()).get()
                    .then(que=>{
                        que.forEach(DOC=>{
                            arrInv.push(DOC.data())
                        })
                        let newArr = []
                        let net01,net02,net03,net04,net05,net06,net07,net08,net09,net10,net11,net12 = 0

                        // Split amt by month
                        arrInv.forEach(rec=>{
                            net01 = 0
                            net02 = 0
                            net03 = 0
                            net04 = 0
                            net05 = 0
                            net06 = 0
                            net07 = 0
                            net08 = 0
                            net09 = 0
                            net10 = 0
                            net11 = 0
                            net12 = 0
                            if(rec.invDate.substr(0,7) == this.year + "-" + "01"){
                                net01 = 0
                                net01 += rec.net
                                newArr.push({code: rec.code.substr(0,1), "01": net01, "02": net02, "03": net03, "04": net04, "05": net05
                                , "06": net06, "07": net07, "08": net08, "09": net09, "10": net10, "11": net11, "12": net12 })
                            }
                            if(rec.invDate.substr(0,7) == this.year + "-" + "02"){
                                net02 = 0
                                net02 += rec.net
                                newArr.push({code: rec.code.substr(0,1), "01": net01, "02": net02, "03": net03, "04": net04, "05": net05
                                , "06": net06, "07": net07, "08": net08, "09": net09, "10": net10, "11": net11, "12": net12 })
                            }
                            if(rec.invDate.substr(0,7) == this.year + "-" + "03"){
                                net03 = 0
                                net03 += rec.net
                                newArr.push({code: rec.code.substr(0,1), "01": net01, "02": net02, "03": net03, "04": net04, "05": net05
                                , "06": net06, "07": net07, "08": net08, "09": net09, "10": net10, "11": net11, "12": net12 })
                            }
                            if(rec.invDate.substr(0,7) == this.year + "-" + "04"){
                                net04 = 0
                                net04 += rec.net
                                newArr.push({code: rec.code.substr(0,1), "01": net01, "02": net02, "03": net03, "04": net04, "05": net05
                                , "06": net06, "07": net07, "08": net08, "09": net09, "10": net10, "11": net11, "12": net12 })
                            }
                            if(rec.invDate.substr(0,7) == this.year + "-" + "05"){
                                net05 = 0
                                net05 += rec.net
                                newArr.push({code: rec.code.substr(0,1), "01": net01, "02": net02, "03": net03, "04": net04, "05": net05
                                , "06": net06, "07": net07, "08": net08, "09": net09, "10": net10, "11": net11, "12": net12 })
                            }
                            if(rec.invDate.substr(0,7) == this.year + "-" + "06"){
                                net06 = 0
                                net06 += rec.net
                                newArr.push({code: rec.code.substr(0,1), "01": net01, "02": net02, "03": net03, "04": net04, "05": net05
                                , "06": net06, "07": net07, "08": net08, "09": net09, "10": net10, "11": net11, "12": net12 })
                            }
                            if(rec.invDate.substr(0,7) == this.year + "-" + "07"){
                                net07 = 0
                                net07 += rec.net
                                newArr.push({code: rec.code.substr(0,1), "01": net01, "02": net02, "03": net03, "04": net04, "05": net05
                                , "06": net06, "07": net07, "08": net08, "09": net09, "10": net10, "11": net11, "12": net12 })
                            }
                            if(rec.invDate.substr(0,7) == this.year + "-" + "08"){
                                net08 = 0
                                net08 += rec.net
                                newArr.push({code: rec.code.substr(0,1), "01": net01, "02": net02, "03": net03, "04": net04, "05": net05
                                , "06": net06, "07": net07, "08": net08, "09": net09, "10": net10, "11": net11, "12": net12 })
                            }
                            if(rec.invDate.substr(0,7) == this.year + "-" + "09"){
                                net09 = 0
                                net09 += rec.net
                                newArr.push({code: rec.code.substr(0,1), "01": net01, "02": net02, "03": net03, "04": net04, "05": net05
                                , "06": net06, "07": net07, "08": net08, "09": net09, "10": net10, "11": net11, "12": net12 })
                            }
                            if(rec.invDate.substr(0,7) == this.year + "-" + "10"){
                                net10 = 0
                                net10 += rec.net
                                newArr.push({code: rec.code.substr(0,1), "01": net01, "02": net02, "03": net03, "04": net04, "05": net05
                                , "06": net06, "07": net07, "08": net08, "09": net09, "10": net10, "11": net11, "12": net12 })
                            }
                            if(rec.invDate.substr(0,7) == this.year + "-" + "11"){
                                net11 = 0
                                net11 += rec.net
                                newArr.push({code: rec.code.substr(0,1), "01": net01, "02": net02, "03": net03, "04": net04, "05": net05
                                , "06": net06, "07": net07, "08": net08, "09": net09, "10": net10, "11": net11, "12": net12 })
                            }
                            if(rec.invDate.substr(0,7) == this.year + "-" + "12"){
                                net12 = 0
                                net12 += rec.net
                                newArr.push({code: rec.code.substr(0,1), "01": net01, "02": net02, "03": net03, "04": net04, "05": net05
                                , "06": net06, "07": net07, "08": net08, "09": net09, "10": net10, "11": net11, "12": net12 })
                            }
                        })

                        // Sort code
                        newArr.sort((a, b) => a.code.localeCompare(b.code))

                        let arr = null
                        let count = 0
                        let net = []

                        // Do not remove duplicate code If duplicate, add net together
                        for (let i = 0; i < newArr.length; i++) {
                            if(newArr[i].code != arr){
                                if(count > 0){
                                    this.custGrp.push({group: arr, "01": net["01"], "02": net["02"]
                                    , "03": net["03"], "04": net["04"], "05": net["05"], "06": net["06"]
                                    , "07": net["07"], "08": net["08"], "09": net["09"], "10": net["10"]
                                    , "11": net["11"], "12": net["12"]})
                                }
                                net = []
                                net01 = 0
                                net02 = 0
                                net03 = 0
                                net04 = 0
                                net05 = 0
                                net06 = 0
                                net07 = 0
                                net08 = 0
                                net09 = 0
                                net10 = 0
                                net11 = 0
                                net12 = 0
                                net = {"01": net01 += newArr[i]["01"], "02": net02 += newArr[i]["02"], "03": net03 += newArr[i]["03"],
                                    "04": net04 += newArr[i]["04"], "05": net05 += newArr[i]["05"], "06": net06 += newArr[i]["06"],
                                    "07": net07 += newArr[i]["07"], "08": net08 += newArr[i]["08"], "09": net09 += newArr[i]["09"],
                                    "10": net10 += newArr[i]["10"], "11": net11 += newArr[i]["11"], "12": net12 += newArr[i]["12"],}
                                arr = newArr[i].code
                                count = 1
                            }
                            else{
                                net = {"01": net01 += newArr[i]["01"], "02": net02 += newArr[i]["02"], "03": net03 += newArr[i]["03"],
                                    "04": net04 += newArr[i]["04"], "05": net05 += newArr[i]["05"], "06": net06 += newArr[i]["06"],
                                    "07": net07 += newArr[i]["07"], "08": net08 += newArr[i]["08"], "09": net09 += newArr[i]["09"],
                                    "10": net10 += newArr[i]["10"], "11": net11 += newArr[i]["11"], "12": net12 += newArr[i]["12"],}
                                count++
                            }
                        }
                        if(count > 0){
                            this.custGrp.push({group: arr, "01": net["01"], "02": net["02"], "03": net["03"], "04": net["04"]
                            , "05": net["05"], "06": net["06"], "07": net["07"], "08": net["08"]
                            , "09": net["09"], "10": net["10"], "11": net["11"], "12": net["12"]})
                        }

                        // If the current month has not yet been set, return the value as 0.
                        let lastYear = new Date().toISOString().substr(0,4)
                        app.custGrp.forEach(rec=>{
                            if(lastYear == app.year){
                                if(app.month < 2){
                                    rec["2"] = 0
                                }
                                if(app.month < 3){
                                    rec["3"] = 0
                                }
                                if(app.month < 4){
                                    rec["4"] = 0
                                }
                                if(app.month < 5){
                                    rec["5"] = 0
                                }
                                if(app.month < 6){
                                    rec["6"] = 0
                                }
                                if(app.month < 7){
                                    rec["7"] = 0
                                }
                                if(app.month < 8){
                                    rec["8"] = 0
                                }
                                if(app.month < 9){
                                    rec["9"] = 0
                                }
                                if(app.month < 10){
                                    rec["10"] = 0
                                }
                                if(app.month < 11){
                                    rec["11"] = 0
                                }
                                if(app.month < 12){
                                    rec["12"] = 0
                                }
                            }
                        })
                    })
                }
            })
        },

        // 
        getInv(){
            let app = this
            let curYear = this.year*1 + 1
            db.collection("invoice").where("status", "==", "Open")
            .where("invDate", ">", this.year).where("invDate", "<", curYear.toString()).get()
            .then(query=>{
                let arrInv = []
                this.custGrp = []
                query.forEach(doc=>{
                    arrInv.push(doc.data())
                })
                db.collection("invoice").where("status", "==", "Closed")
                .where("invDate", ">", this.year).where("invDate", "<", curYear.toString()).get()
                .then(que=>{
                    que.forEach(DOC=>{
                        arrInv.push(DOC.data())
                    })
                    let newArr = []
                    let net01,net02,net03,net04,net05,net06,net07,net08,net09,net10,net11,net12 = 0

                    // Split amt by month
                    arrInv.forEach(rec=>{
                        net01 = 0
                        net02 = 0
                        net03 = 0
                        net04 = 0
                        net05 = 0
                        net06 = 0
                        net07 = 0
                        net08 = 0
                        net09 = 0
                        net10 = 0
                        net11 = 0
                        net12 = 0
                        if(rec.invDate.substr(0,7) == this.year + "-" + "01"){
                            net01 = 0
                            net01 += rec.net
                            newArr.push({code: rec.code.substr(0,1), "01": net01, "02": net02, "03": net03, "04": net04, "05": net05
                            , "06": net06, "07": net07, "08": net08, "09": net09, "10": net10, "11": net11, "12": net12 })
                        }
                        if(rec.invDate.substr(0,7) == this.year + "-" + "02"){
                            net02 = 0
                            net02 += rec.net
                            newArr.push({code: rec.code.substr(0,1), "01": net01, "02": net02, "03": net03, "04": net04, "05": net05
                            , "06": net06, "07": net07, "08": net08, "09": net09, "10": net10, "11": net11, "12": net12 })
                        }
                        if(rec.invDate.substr(0,7) == this.year + "-" + "03"){
                            net03 = 0
                            net03 += rec.net
                            newArr.push({code: rec.code.substr(0,1), "01": net01, "02": net02, "03": net03, "04": net04, "05": net05
                            , "06": net06, "07": net07, "08": net08, "09": net09, "10": net10, "11": net11, "12": net12 })
                        }
                        if(rec.invDate.substr(0,7) == this.year + "-" + "04"){
                            net04 = 0
                            net04 += rec.net
                            newArr.push({code: rec.code.substr(0,1), "01": net01, "02": net02, "03": net03, "04": net04, "05": net05
                            , "06": net06, "07": net07, "08": net08, "09": net09, "10": net10, "11": net11, "12": net12 })
                        }
                        if(rec.invDate.substr(0,7) == this.year + "-" + "05"){
                            net05 = 0
                            net05 += rec.net
                            newArr.push({code: rec.code.substr(0,1), "01": net01, "02": net02, "03": net03, "04": net04, "05": net05
                            , "06": net06, "07": net07, "08": net08, "09": net09, "10": net10, "11": net11, "12": net12 })
                        }
                        if(rec.invDate.substr(0,7) == this.year + "-" + "06"){
                            net06 = 0
                            net06 += rec.net
                            newArr.push({code: rec.code.substr(0,1), "01": net01, "02": net02, "03": net03, "04": net04, "05": net05
                            , "06": net06, "07": net07, "08": net08, "09": net09, "10": net10, "11": net11, "12": net12 })
                        }
                        if(rec.invDate.substr(0,7) == this.year + "-" + "07"){
                            net07 = 0
                            net07 += rec.net
                            newArr.push({code: rec.code.substr(0,1), "01": net01, "02": net02, "03": net03, "04": net04, "05": net05
                            , "06": net06, "07": net07, "08": net08, "09": net09, "10": net10, "11": net11, "12": net12 })
                        }
                        if(rec.invDate.substr(0,7) == this.year + "-" + "08"){
                            net08 = 0
                            net08 += rec.net
                            newArr.push({code: rec.code.substr(0,1), "01": net01, "02": net02, "03": net03, "04": net04, "05": net05
                            , "06": net06, "07": net07, "08": net08, "09": net09, "10": net10, "11": net11, "12": net12 })
                        }
                        if(rec.invDate.substr(0,7) == this.year + "-" + "09"){
                            net09 = 0
                            net09 += rec.net
                            newArr.push({code: rec.code.substr(0,1), "01": net01, "02": net02, "03": net03, "04": net04, "05": net05
                            , "06": net06, "07": net07, "08": net08, "09": net09, "10": net10, "11": net11, "12": net12 })
                        }
                        if(rec.invDate.substr(0,7) == this.year + "-" + "10"){
                            net10 = 0
                            net10 += rec.net
                            newArr.push({code: rec.code.substr(0,1), "01": net01, "02": net02, "03": net03, "04": net04, "05": net05
                            , "06": net06, "07": net07, "08": net08, "09": net09, "10": net10, "11": net11, "12": net12 })
                        }
                        if(rec.invDate.substr(0,7) == this.year + "-" + "11"){
                            net11 = 0
                            net11 += rec.net
                            newArr.push({code: rec.code.substr(0,1), "01": net01, "02": net02, "03": net03, "04": net04, "05": net05
                            , "06": net06, "07": net07, "08": net08, "09": net09, "10": net10, "11": net11, "12": net12 })
                        }
                        if(rec.invDate.substr(0,7) == this.year + "-" + "12"){
                            net12 = 0
                            net12 += rec.net
                            newArr.push({code: rec.code.substr(0,1), "01": net01, "02": net02, "03": net03, "04": net04, "05": net05
                            , "06": net06, "07": net07, "08": net08, "09": net09, "10": net10, "11": net11, "12": net12 })
                        }
                    })

                    // Sort code
                    newArr.sort((a, b) => a.code.localeCompare(b.code))

                    let arr = null
                    let count = 0
                    let net = []

                    // Do not remove duplicate code If duplicate, add net together
                    for (let i = 0; i < newArr.length; i++) {
                        if(newArr[i].code != arr){
                            if(count > 0){
                                this.custGrp.push({group: arr, "01": net["01"], "02": net["02"]
                                , "03": net["03"], "04": net["04"], "05": net["05"], "06": net["06"]
                                , "07": net["07"], "08": net["08"], "09": net["09"], "10": net["10"]
                                , "11": net["11"], "12": net["12"]})
                            }
                            net = []
                            net01 = 0
                            net02 = 0
                            net03 = 0
                            net04 = 0
                            net05 = 0
                            net06 = 0
                            net07 = 0
                            net08 = 0
                            net09 = 0
                            net10 = 0
                            net11 = 0
                            net12 = 0
                            net = {"01": net01 += newArr[i]["01"], "02": net02 += newArr[i]["02"], "03": net03 += newArr[i]["03"],
                                "04": net04 += newArr[i]["04"], "05": net05 += newArr[i]["05"], "06": net06 += newArr[i]["06"],
                                "07": net07 += newArr[i]["07"], "08": net08 += newArr[i]["08"], "09": net09 += newArr[i]["09"],
                                "10": net10 += newArr[i]["10"], "11": net11 += newArr[i]["11"], "12": net12 += newArr[i]["12"],}
                            arr = newArr[i].code
                            count = 1
                        }
                        else{
                            net = {"01": net01 += newArr[i]["01"], "02": net02 += newArr[i]["02"], "03": net03 += newArr[i]["03"],
                                "04": net04 += newArr[i]["04"], "05": net05 += newArr[i]["05"], "06": net06 += newArr[i]["06"],
                                "07": net07 += newArr[i]["07"], "08": net08 += newArr[i]["08"], "09": net09 += newArr[i]["09"],
                                "10": net10 += newArr[i]["10"], "11": net11 += newArr[i]["11"], "12": net12 += newArr[i]["12"],}
                            count++
                        }
                    }
                    if(count > 0){
                        this.custGrp.push({group: arr, "01": net["01"], "02": net["02"], "03": net["03"], "04": net["04"]
                        , "05": net["05"], "06": net["06"], "07": net["07"], "08": net["08"]
                        , "09": net["09"], "10": net["10"], "11": net["11"], "12": net["12"]})
                    }

                    // If the current month has not yet been set, return the value as 0.
                    app.custGrp.forEach(rec=>{
                        if(app.month < 2){
                            rec["2"] = 0
                        }
                        if(app.month < 3){
                            rec["3"] = 0
                        }
                        if(app.month < 4){
                            rec["4"] = 0
                        }
                        if(app.month < 5){
                            rec["5"] = 0
                        }
                        if(app.month < 6){
                            rec["6"] = 0
                        }
                        if(app.month < 7){
                            rec["7"] = 0
                        }
                        if(app.month < 8){
                            rec["8"] = 0
                        }
                        if(app.month < 9){
                            rec["9"] = 0
                        }
                        if(app.month < 10){
                            rec["10"] = 0
                        }
                        if(app.month < 11){
                            rec["11"] = 0
                        }
                        if(app.month < 12){
                            rec["12"] = 0
                        }
                    })
                })
            })
        }
    },
    computed:{

        // Sum jan from trial balance custGrp
        sum01(){
            return this.custGrp.reduce((total,item)=> total+(item['01']),0)
        },

        // Sum feb from trial balance custGrp
        sum02(){
            return this.custGrp.reduce((total,item)=> total+(item['02']),0)
        },

        // Sum mar from trial balance custGrp
        sum03(){
            return this.custGrp.reduce((total,item)=> total+(item['03']),0)
        },

        // Sum apr from trial balance custGrp
        sum04(){
            return this.custGrp.reduce((total,item)=> total+(item['04']),0)
        },

        // Sum may from trial balance custGrp
        sum05(){
            return this.custGrp.reduce((total,item)=> total+(item['05']),0)
        },

        // Sum jun from trial balance custGrp
        sum06(){
            return this.custGrp.reduce((total,item)=> total+(item['06']),0)
        },

        // Sum jul from trial balance custGrp
        sum07(){
            return this.custGrp.reduce((total,item)=> total+(item['07']),0)
        },

        // Sum gug from trial balance custGrp
        sum08(){
            return this.custGrp.reduce((total,item)=> total+(item['08']),0)
        },

        // Sum sep from trial balance custGrp
        sum09(){
            return this.custGrp.reduce((total,item)=> total+(item['09']),0)
        },

        // Sum oct from trial balance custGrp
        sum10(){
            return this.custGrp.reduce((total,item)=> total+(item['10']),0)
        },

        // Sum nov from trial balance custGrp
        sum11(){
            return this.custGrp.reduce((total,item)=> total+(item['11']),0)
        },

        // Sum dec from trial balance custGrp
        sum12(){
            return this.custGrp.reduce((total,item)=> total+(item['12']),0)
        },

        // Sum c/f from trial balance custGrp
        sumCf(){
            return this.custGrp.reduce((total,item)=> total+
            (
                item['01'] +
                item['02'] +
                item['03'] +
                item['04'] +
                item['05'] +
                item['06'] +
                item['07'] +
                item['08'] +
                item['09'] +
                item['10'] +
                item['11'] +
                item['12'] 
            ),0)
        },
    },
    mounted(){
        this.getInv()
        db.collection("code").doc("runYear").get()
        .then(doc=>{
            let data = doc.data().year
            data.forEach(rec=>{
                this.itemYear.push(rec)
            })
        })
    }
}
</script>